// @ts-strict-ignore
import 'intersection-observer'
import smoothscroll from 'smoothscroll-polyfill'

export async function polyfill() {
  // Smooth scholl
  smoothscroll.polyfill()
}
polyfill()
